import { CourierService } from "./../_services/courier.service";
import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Globals } from "../globals";
import { ProductContent } from "../_models/product-content";
import { ProductPrice } from "../_models/product-price";
import _ from "lodash";
import { CountryService } from "../_services/country.service";
import { Country } from "../_models/country";
import { Courier } from "../_models/courier";

@Component({
  selector: "app-view-courier-page",
  templateUrl: "./view-courier-page.component.html",
  styleUrls: ["./view-courier-page.component.scss"],
})
export class ViewCourierPageComponent implements OnInit {
  public categories = new FormControl();
  public isDataLoaded = false;
  public isModified = false;
  public newProductContent = new ProductContent();
  public courier: Courier;
  public countries: Country[];
  public showAddContents = false;
  public selectedCountry: number = 0;
  public courierTypes = [
    {
      id: "DELIVERY",
      name: "Delivery",
    },
    { id: "PICKUP", name: "Pickup" },
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    public countryService: CountryService,
    public courierService: CourierService,
    public globals: Globals,
    private location: Location,
    public snackBar: MatSnackBar,
    public uploadDialog: MatDialog,
    private router: Router
  ) {}

  public activate(): void {
    this.courier.active = true;
    this.save();
  }

  public back(): void {
    this.location.back();
  }

  public cancel(): void {
    this.refresh();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public deactivate(): void {
    this.courier.active = false;
    this.save();
  }

  public delete() {
    this.courierService.deleteCourier(this.courier.id).subscribe(
      (res) => {
        this.router.navigate(["regional", "courier"]);
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public loadData(courierId: number) {
    this.courierService.getCourier(courierId).subscribe(
      (courier) => {
        this.courier = courier;
        this.isDataLoaded = true;
        this.isModified = false;
      },
      (err) => {
        if (err.status == 404) {
          this.isDataLoaded = true;
          this.showErrorMessage("Courier not found");
        }
      }
    );
  }

  public ngOnInit(): void {
    this.countryService.getCountries().subscribe(
      (countries) => {
        this.countries = countries;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve countries");
      }
    );
    this.activatedRoute.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          const courierId = params.get("id");
          if (!this.globals.isNullOrEmpty(courierId)) {
            this.loadData(parseInt(courierId, 10));
          } else {
            this.showErrorMessage("Please specify the courier Id!");
          }

          return Promise.resolve();
        })
      )
      .subscribe();
  }

  public refresh(): void {
    this.isDataLoaded = false;
    this.loadData(this.courier.id);
  }

  isCourierValid() {
    return this.courier.name && this.courier.code;
  }

  public save(): void {
    if (!this.isCourierValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.courierService.updateCourier(this.courier).subscribe(
      (res) => {
        this.refresh();
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public updateList(price: ProductPrice, propertys: string, value: any) {
    console.log(value);
  }
}
